import { r as reactExports, u as useConfigContext, R as React, c as clsx, C as ChevronLeftIcon, a as ChevronRightIcon } from './product-card-full-CT0xB3Kg.js';
import { S as Swiper, A as A11y, N as Navigation, P as Pagination, a as Scrollbar, b as Autoplay } from './autoplay-1i0pWSBG.js';
import './api-CNH57r5e.js';
import './js.cookie-BP4gknLK.js';
import './facets-BphZ0Xme.js';

Swiper.use([A11y, Navigation, Pagination, Scrollbar, Autoplay]);

 





const Carousel = reactExports.forwardRef(
  ({ title, slides, swiperNavigationClass = 'absolute left-0 right-0 top-0 grid grid-cols-4 gap-8' }, ref) => {
    const { translations } = useConfigContext();
    const id = reactExports.useMemo(() => {
      const now = new Date().getTime();

      return Math.floor(Math.random() * now).toString(16);
    }, []);
    const [swiperInstance, setSwiperInstance] = reactExports.useState(null);
    const swiperDomRefCB = reactExports.useCallback(
      (node) => {
        if (node) {
          const swiperInstance = new Swiper(node, {
            slidesPerView: 2,
            spaceBetween: 16,
            loop: false,
            navigation: {
              nextEl: `.swiper-button-next-${id}`,
              prevEl: `.swiper-button-prev-${id}`,
            },
            pagination: {
              el: `.swiper-pagination-${id}`,
              type: 'bullets',
              clickable: true,
            },
            breakpoints: {
              '768': { slidesPerView: 3, spaceBetween: 32 },
              '1024': { slidesPerView: 4, spaceBetween: 32 },
            },
          });

          setSwiperInstance(swiperInstance);
        }
      },
      [id]
    );

    reactExports.useEffect(() => {
      return () => {
        if (swiperInstance) {
          swiperInstance.destroy();
        }
      };
    }, [swiperInstance]);

    return (
      React.createElement('div', { ref: ref, className: "container overflow-hidden" ,}
        , title && (
          React.createElement('header', { className: "container__header " ,}
            , React.createElement('h2', { className: "container__title h3 text-left leading-6 md:text-left md:leading-8"     ,}, title)
          )
        )
        , React.createElement('div', { className: "container__content overflow-hidden text-left"  ,}
          , React.createElement('div', { className: "relative",}
            /* Swiper */
            , React.createElement('div', { ref: swiperDomRefCB, className: "swiper swiper-pagination-active" ,}
              /* Swiper Wrapper */
              , React.createElement('div', { className: "swiper-wrapper",}
                , slides.map((slide, index) => (
                  React.createElement('div', {
                    key: `${id}-${index}`,
                    className: "swiper-slide -mb-1 h-auto w-full sm:w-1/2 md:w-1/3 lg:w-1/4"      ,
                    'data-swiper-slide-index': index + 1,}

                    , slide()
                  )
                ))
              )
              /* Swiper pagination */
              , React.createElement('div', { className: `swiper-pagination swiper-pagination-${id} md:hidden`,})
            )
            /* Swiper navigation */
            , React.createElement('div', { className: clsx(swiperNavigationClass),}
              , React.createElement('div', { className: "col-span-4 sm:col-span-2 lg:col-span-1"  ,}
                , React.createElement('div', { className: "aspect-[1/1]",})
              )
              , React.createElement('button', {
                type: "button",
                className: `swiper-button-prev swiper-button-prev-${id} -left-5 transition-all duration-200 hover:bg-primary hover:opacity-100 aria-disabled:hidden lg:-left-[3.25rem]`,}

                , React.createElement(ChevronLeftIcon, { title: translations.accessibility.previousSlide,} )
              )
              , React.createElement('button', {
                type: "button",
                className: `swiper-button-next swiper-button-next-${id} -right-5 transition-all duration-200 hover:bg-primary hover:opacity-100 aria-disabled:hidden lg:-right-[3.25rem]`,}

                , React.createElement(ChevronRightIcon, { title: translations.accessibility.nextSlide,} )
              )
            )
          )
        )
      )
    );
  }
);

export { Carousel as C };
